import { Grid } from '@mui/material';
import { ChartFrequency, CommunicationType } from 'wisestep-api';

import {
  defaultCallAnalyticsValues,
  defaultMISAnalyticsPaylod,
} from '../utils/CallsAnalyticsHelper';

import CareerPageAnalyticsTable from './components/CareerPageAnalyticsTable';
import CommunicationsTable from './components/CommunicationsTable';
import CVViewsAcrossWorkspacesTable from './components/CVViewsAcrossWorkspacesTable';
import EmailsByAllWorkspacesTable from './components/EmailsByAllWorkspacesTable';
import EmailsWithProviderTable from './components/EmailsWithProviderTable';
import InteractionsWithSource from './components/InteractionsWithSource';
import JobsPostedOnJobBoardsTable from './components/JobsPostedOnJobBoardsTable';
import JobsTrendAcrossWorkspaceTable from './components/JobsTrendAcrossWorkspaceTable';
import MappingsAndUploadsTable from './components/MappingsAndUploadsTable';
import SearchQueriesPerformedTable from './components/SearchQueriesPerformedTable';
import TasksByAllWorkspacesTable from './components/TasksByAllWorkspacesTable';
import PrivateExtensionUsageTable from './PrivateExtensionUsageTable';

const InternalMISAcrossWorkspaces = () => {
  const query = defaultMISAnalyticsPaylod;
  query.frequency = ChartFrequency.WEEKLY;
  query.loadAllWorkspacesData = true;
  return (
    <Grid container>
      <JobsTrendAcrossWorkspaceTable query={query} />
      <JobsPostedOnJobBoardsTable query={query} />
      <MappingsAndUploadsTable query={query} />
      <SearchQueriesPerformedTable query={query} />
      <CareerPageAnalyticsTable query={query} />
      <TasksByAllWorkspacesTable query={query} />
      <EmailsByAllWorkspacesTable query={query} />
      <PrivateExtensionUsageTable query={query} />
      <InteractionsWithSource
        query={{
          ...query,
          fromDay: '60d',
          jobCandidateMapping: false,
        }}
        title="Submissions in last 60 Days - Weekly"
      />
      <InteractionsWithSource
        query={{
          ...query,
          fromDay: '60d',
          jobCandidateMapping: true,
        }}
        title="Mappings in last 60 Days - Weekly"
      />
      <InteractionsWithSource
        query={{
          ...query,
          fromDay: '60d',
          jobCandidateMapping: true,
          candidateStatusTags: ['applied'],
        }}
        title="Applications received in last 60 Days - Weekly"
      />
      <CVViewsAcrossWorkspacesTable query={{ ...query, fromDay: '60d' }} />
      <EmailsWithProviderTable query={{ ...query, fromDay: '60d' }} />
      <CommunicationsTable
        query={{
          ...defaultCallAnalyticsValues,
          fromDay: '60d',
          type: CommunicationType.SMS,
          loadAllWorkspacesData: true,
          frequency: ChartFrequency.WEEKLY,
        }}
      />
    </Grid>
  );
};

export default InternalMISAcrossWorkspaces;
